import * as language from 'src/i18n/en';

export const DOCUMENT_TYPES = [
  { key: 'paystub', value: 'PAYSTUB', label: language.default.dup_document_type_paystub },
  {
    key: 'bank_statement',
    value: 'BANK_STATEMENT',
    label: language.default.dup_document_type_bank_statement
  },
  {
    key: 'cash_app_statement',
    value: 'CASH_APP_STATEMENT',
    label: language.default.dup_document_type_cash_app_statement
  },
  {
    key: 'child_support',
    value: 'CHILD_SUPPORT',
    label: language.default.dup_document_type_child_support
  },
  {
    key: 'credit_debit_card_statement',
    value: 'CREDIT_DEBIT_CARD_STATEMENT',
    label: language.default.dup_document_type_credit_debit_card_statement
  },
  {
    key: 'department_of_veterans_affairs_benefit_letter',
    value: 'DEPARTMENT_OF_VETERANS_AFFAIRS_BENEFIT_LETTER',
    label: language.default.dup_document_type_department_of_veterans_affairs_benefit_letter
  },
  {
    key: 'financial_aid',
    value: 'FINANCIAL_AID',
    label: language.default.dup_document_type_financial_aid
  },
  {
    key: 'investment_account',
    value: 'INVESTMENT_ACCOUNT',
    label: language.default.dup_document_type_investment_account
  },
  {
    key: 'offer_letter',
    value: 'OFFER_LETTER',
    label: language.default.dup_document_type_offer_letter
  },
  {
    key: 'social_security_benefits_letter',
    value: 'SOCIAL_SECURITY_BENEFITS_LETTER',
    label: language.default.dup_document_type_social_security_benefits_letter
  },
  {
    key: 'social_security_statement',
    value: 'SOCIAL_SECURITY_STATEMENT',
    label: language.default.dup_document_type_social_security_statement
  },
  {
    key: 'tax_transcript',
    value: 'TAX_TRANSCRIPT',
    label: language.default.dup_document_type_tax_transcript
  },
  {
    key: 'utility_bill',
    value: 'UTILITY_BILL',
    label: language.default.dup_document_type_utility_bill
  },
  {
    key: 'student_visa',
    value: 'STUDENT_VISA',
    label: language.default.dup_document_type_student_visa
  },
  {
    key: 'cpa_letter',
    value: 'CPA_LETTER',
    label: language.default.dup_document_type_cpa_letter
  },
  {
    key: 'housing_voucher',
    value: 'HOUSING_VOUCHER',
    label: language.default.dup_document_type_housing_voucher
  },
  {
    key: 'military_bah',
    value: 'MILITARY_BAH',
    label: language.default.dup_document_type_military_bah
  },
  {
    key: 'scanned_document',
    value: 'SCANNED_DOCUMENT',
    label: language.default.dup_document_type_scanned_document
  },
  {
    key: 'other',
    value: 'OTHER',
    label: language.default.dup_document_type_other
  }
];
